import { useEffect, useState } from 'react';
import Highcharts from 'highcharts/highmaps';
import HighchartsReact from 'highcharts-react-official';

interface ImpressoesPorEstadoChartProps {
    series: any[];
}

const ImpressionsByStateChart = ({ series }: ImpressoesPorEstadoChartProps) => {
    const [options, setOptions] = useState<Highcharts.Options>();
    const stateISO = {
        'Acre': 'AC',
        'Alagoas': 'AL',
        'Amapá': 'AP',
        'Amazonas': 'AM',
        'Bahia': 'BA',
        'Ceará': 'CE',
        'Distrito Federal': 'DF',
        'Espírito Santo': 'ES',
        'Goiás': 'GO',
        'Maranhão': 'MA',
        'Mato Grosso': 'MT',
        'Mato Grosso do Sul': 'MS',
        'Minas Gerais': 'MG',
        'Pará': 'PA',
        'Paraíba': 'PB',
        'Paraná': 'PR',
        'Pernambuco': 'PE',
        'Piauí': 'PI',
        'Rio de Janeiro': 'RJ',
        'Rio Grande do Norte': 'RN',
        'Rio Grande do Sul': 'RS',
        'Rondônia': 'RO',
        'Roraima': 'RR',
        'São Paulo': 'SP',
        'Sergipe': 'SE',
        'Tocantins': 'TO',
    };

    const fetchMapData = async () => {
        // https://code.highcharts.com/mapdata/countries/br/br-all.topo.json
        const response = await fetch('/highcharts/br-all.topo.json');
        const mapData = await response.json();

        const data: [string, number][] = series.reduce((acc, item) => {
            // @ts-ignore
            const state = stateISO[item.state];
            if (state) {
                acc.push([`br-${state.toLowerCase()}`, item.impression]);
            }

            return acc;
        }, []);

        setOptions({
            title: {
                text: undefined,
            },
            legend: {
                enabled: false,
            },
            chart: {
                map: mapData,
            },
            colorAxis: {
                min: 0,
            },
            credits: {
                enabled: false,
            },
            accessibility: {
                enabled: false,
            },
            series: [{
                type: 'map',
                name: 'Estado',
                data: data,
                states: {
                    hover: {
                        color: '#BADA55',
                    },
                },
                dataLabels: {
                    enabled: false,
                },
            }],
        });
    };

    useEffect(() => {
        fetchMapData();
    }, []);

    return (
        <>
            {options ? (
                <HighchartsReact
                    highcharts={Highcharts}
                    constructorType={'mapChart'}
                    options={options}
                />
            ) : (
                <p>Carregando dados do mapa...</p>
            )}
        </>
    );
};

export default ImpressionsByStateChart;